/**
 * Controle de notificacoes, na aba Configuracoes.
 *
 * A tela existe porque push nao pode ser ligado sozinho: o navegador exige que
 * o pedido de permissao parta de um GESTO da pessoa. Ativar no primeiro
 * carregamento faria o Chrome recusar o prompt e — pior — queimaria a unica
 * chance de perguntar, porque um "negar" e definitivo.
 */

import { usePush } from './usePush.js';

export function NotificationsPanel() {
  const { state, erro, ativar, desativar, ocupado } = usePush();

  return (
    <section className="flex flex-col gap-3 rounded bg-surface p-3 shadow-card">
      <h2 className="font-display font-semibold">Notificações</h2>

      <p className="text-sm text-text-mut">
        Avisos de lembrete das tarefas, no horário que você marcar.
      </p>

      {state === 'carregando' ? <div className="h-10 animate-pulse rounded bg-surface-2" /> : null}

      {state === 'indisponivel' ? (
        <p className="text-sm text-text-mut">
          Este navegador não oferece notificações, ou o servidor ainda não tem as chaves
          configuradas.
        </p>
      ) : null}

      {state === 'bloqueado' ? (
        // Nenhum codigo reabre o prompt depois de um "negar": so as
        // configuracoes do navegador revertem. Oferecer o botao aqui seria
        // oferecer algo que nunca funciona.
        <p className="text-sm" role="alert">
          As notificações estão bloqueadas para este site. Para liberar, abra as permissões do
          navegador (o cadeado ao lado do endereço) e permita notificações.
        </p>
      ) : null}

      {state === 'desativado' || state === 'ativo' ? (
        <div className="flex items-center justify-between gap-3">
          <span className="text-sm">
            {state === 'ativo' ? 'Ativadas neste aparelho.' : 'Desativadas neste aparelho.'}
          </span>

          <button
            type="button"
            onClick={() => void (state === 'ativo' ? desativar() : ativar())}
            disabled={ocupado}
            className={[
              'min-h-touch shrink-0 rounded-sm px-3 text-sm font-medium transition-colors duration-150',
              state === 'ativo'
                ? 'border border-border text-text hover:bg-surface-2'
                : 'bg-brand-blue text-white hover:opacity-90',
              ocupado ? 'opacity-50' : '',
            ].join(' ')}
          >
            {state === 'ativo' ? 'Desativar' : 'Ativar'}
          </button>
        </div>
      ) : null}

      {erro ? (
        <p className="text-sm text-overdue" role="alert">
          {erro}
        </p>
      ) : null}

      {/*
        A pegadinha mais comum do push na web, e a que gera mais "nao funciona":
        no iPhone o Safari so entrega notificacao para PWA INSTALADA. Aberta
        pelo navegador, a inscricao ate acontece e nada chega.
      */}
      <p className="text-xs text-text-mut">
        No iPhone e iPad, as notificações só funcionam com o app instalado na tela de início
        (Compartilhar → Adicionar à Tela de Início), no iOS 16.4 ou mais recente.
      </p>
    </section>
  );
}
